/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file SiteAsset component
 * @author Dustin Gage
 */

declare let __webpack_public_path__: string;

import React, { memo, ReactElement, ImgHTMLAttributes } from "react";

import { getRootRelativePath } from "../api/get-root-relative-path";

interface IProps extends ImgHTMLAttributes<HTMLImageElement> {
	localPath: string;
}

export const SiteImage = memo(function SiteImage(props: IProps): ReactElement {
	const { localPath } = props;
	const imgPath = getRootRelativePath(localPath);

	return <img src={imgPath} />;
});
